import React, { useState, Component } from 'react';
import { MessageCircle, Send, MapPin, Mail, Phone, CheckCircle } from 'lucide-react';
export function ContactSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    const form = e.currentTarget;
    const formData = new FormData(form);
    try {
      await fetch('https://formsubmit.co/ajax/nmservicesww@gmail.com', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });
      setIsSubmitted(true);
    } catch (err) {
      // Fallback: open mailto with form data
      const name = formData.get('name') || '';
      const contact = formData.get('contact') || '';
      const business = formData.get('business') || '';
      const website = formData.get('website') || '';
      const message = formData.get('message') || '';
      const subject = `Website Quote Request from ${name}`;
      const body = `Name: ${name}\nContact: ${contact}\nBusiness Type: ${business}\nCurrent Website: ${website}\n\nMessage:\n${message}`;
      window.location.href = `mailto:nmservicesww@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      setIsSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contact" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#080808'
  }} data-id="element-75">
      <div className="max-w-5xl mx-auto" data-id="element-76">
        <div className="text-center mb-12 reveal" data-id="element-77">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-78">
            Get Your Dublin Website Quote
          </h2>
          <p className="text-white/60" data-id="element-79">Fast response. No obligation.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-80">
          <div className="space-y-8 reveal" data-id="element-81">
            <div className="space-y-4" data-id="element-82">
              <h3 className="text-xl font-bold text-white" data-id="element-83">Quick Chat</h3>
              <div className="flex flex-col space-y-3" data-id="element-84">
                <a href="https://wa.me/36707559881?text=Hi%2C%20I%27m%20in%20Dublin.%20I%20want%20the%20%E2%82%AC249%20website%20package.%20My%20business%20is%3A%20____" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2 bg-[#25D366] hover:bg-[#20bd5a] text-white py-3 rounded-lg font-medium transition-colors" data-id="element-85">
                  <MessageCircle className="w-5 h-5" data-id="element-86" />
                  <span data-id="element-87">Chat on WhatsApp</span>
                </a>
                <a href="https://line.me/ti/p/VcfecNpfWu" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2 bg-[#06C755] hover:bg-[#05b54d] text-white py-3 rounded-lg font-medium transition-colors" data-id="element-88">
                  <MessageCircle className="w-5 h-5" data-id="element-89" />
                  <span data-id="element-90">Chat on LINE</span>
                </a>
              </div>
            </div>

            <div className="space-y-4 pt-4 border-t border-white/10" data-id="element-91">
              <h3 className="text-xl font-bold text-white" data-id="element-92">Contact Details</h3>
              <ul className="space-y-4" data-id="element-93">
                <li className="flex items-start space-x-3" data-id="element-94">
                  <Mail className="w-5 h-5 text-[#c9a84c] mt-1" data-id="element-95" />
                  <span className="text-white/80" data-id="element-96">nmservicesww@gmail.com</span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-97">
                  <Phone className="w-5 h-5 text-[#c9a84c] mt-1" data-id="element-98" />
                  <div className="text-white/80" data-id="element-99">
                    <p data-id="element-100">Netanel: +66 096 023 1920 (LINE)</p>
                    <p data-id="element-101">WhatsApp: +36 70 755 9881</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3" data-id="element-102">
                  <Phone className="w-5 h-5 text-[#c9a84c] mt-1" data-id="element-103" />
                  <span className="text-white/80" data-id="element-104">
                    Vlad: +66 093 337 6318 (LINE)
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-105">
                  <MapPin className="w-5 h-5 text-[#c9a84c] mt-1" data-id="element-106" />
                  <span className="text-white/80" data-id="element-107">
                    Remote • Dublin-first support
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="p-8 rounded-xl border border-white/[0.06] reveal" style={{
          backgroundColor: '#0a0a0a'
        }} data-id="element-108">
            {isSubmitted ? <div className="h-full flex flex-col items-center justify-center text-center space-y-4 py-12" data-id="element-109">
                <div className="w-16 h-16 bg-[#c9a84c]/20 rounded-full flex items-center justify-center" data-id="element-110">
                  <CheckCircle className="w-8 h-8 text-[#c9a84c]" data-id="element-111" />
                </div>
                <h3 className="text-2xl font-bold text-white" data-id="element-112">Request Sent!</h3>
                <p className="text-white/70" data-id="element-113">
                  Thanks! We'll get back to you within a few hours.
                </p>
                <button onClick={() => setIsSubmitted(false)} className="text-[#c9a84c] hover:underline mt-4" data-id="element-114">
                  Send another message
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-115">
                {/* FormSubmit.co config */}
                <input type="hidden" name="_subject" value="New Website Quote Request — aiwebsitepackage.com" data-id="element-116" />
                <input type="hidden" name="_template" value="table" data-id="element-117" />
                <input type="hidden" name="_captcha" value="false" data-id="element-118" />

                {[{
              label: 'Name *',
              name: 'name',
              placeholder: 'Your name',
              required: true
            }, {
              label: 'Email or WhatsApp *',
              name: 'contact',
              placeholder: 'How can we reach you?',
              required: true
            }, {
              label: 'Business Type *',
              name: 'business',
              placeholder: 'e.g. Restaurant, Plumber, Shop',
              required: true
            }, {
              label: 'Current Website (Optional)',
              name: 'website',
              placeholder: 'example.com',
              required: false
            }].map(field => <div key={field.name} data-id="element-119">
                    <label className="block text-sm font-medium text-white/60 mb-1" data-id="element-120">
                      {field.label}
                    </label>
                    <input type="text" name={field.name} required={field.required} className="w-full border border-white/10 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:border-[#c9a84c] focus:ring-1 focus:ring-[#c9a84c] outline-none transition-all" style={{
                backgroundColor: '#111111'
              }} placeholder={field.placeholder} data-id="element-121" />
                  </div>)}
                <div data-id="element-122">
                  <label className="block text-sm font-medium text-white/60 mb-1" data-id="element-123">
                    Message
                  </label>
                  <textarea name="message" rows={4} className="w-full border border-white/10 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:border-[#c9a84c] focus:ring-1 focus:ring-[#c9a84c] outline-none transition-all resize-none" style={{
                backgroundColor: '#111111'
              }} placeholder="Tell us about your needs..." data-id="element-124"></textarea>
                </div>
                <button type="submit" disabled={isSubmitting} className="w-full bg-[#c9a84c] hover:bg-[#b09242] disabled:opacity-60 text-black font-bold py-4 rounded-lg transition-colors flex items-center justify-center space-x-2" data-id="element-125">
                  <span data-id="element-126">
                    {isSubmitting ? 'Sending...' : 'Send Quote Request'}
                  </span>
                  <Send className="w-4 h-4" data-id="element-127" />
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}